<template>
  <div
    class="global-modal"
    v-if="active"
    @click.self.stop="clickOutside"
    :style="{
      'justify-content': renderVAlign,
      'align-items': renderAlign,
      background: hasBg ? 'rgba(2, 8, 24, 0.62)' : 'transparent',
    }"
    :class="{
      'no-background': transparentBg,
      'full-size': fullsize,
      landscape: isMobileLandscape,
      desktop: !isMobile,
    }"
  >
    <div
      class="modal-container"
      :class="{ 'has-menu-bg': useMenuBg }"
      :style="[
        {
          width: size,
          height: height,
          'overflow-y': allowScroll,
        },
        {
          'border-top-left-radius': getBorderRadiusBySides(0),
          'border-top-right-radius': getBorderRadiusBySides(1),
          'border-bottom-right-radius': getBorderRadiusBySides(2),
          'border-bottom-left-radius': getBorderRadiusBySides(3),
        },
        modalContainerStyles,
      ]"
    >
      <div
        v-if="showHeader"
        class="modal-header"
        :class="{ 'is-mobile': isMobile, 'is-tabs': headerVariant === 'tabs' }"
      >
        <slot name="modalHeader" />
      </div>
      <slot />
      <slot name="errorMsg" />
    </div>
  </div>
</template>
<script>
import { isMobile } from 'mobile-device-detect';

export default {
  data: () => {
    return {
      isMobile,
    };
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    animation: {
      type: String,
      default: 'no-effect',
    },
    hasBg: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'default',
    },
    align: {
      type: String,
      default: 'center',
    },
    valign: {
      type: String,
      default: 'bottom',
    },
    borderRadiusBySide: {
      type: Array,
      default: () => [0, 0, 0, 0],
    },
    overlayClickable: {
      type: Boolean,
      default: true,
    },
    fullsize: {
      type: Boolean,
      default: false,
    },
    transparentBg: {
      type: Boolean,
      default: false,
    },
    allowScroll: {
      type: String,
      default: 'hidden',
    },
    bgColor: {
      type: String,
      default: '#07182c',
    },
    height: {
      type: String,
      default: 'auto',
    },
    showHeader: {
      type: Boolean,
      default: false,
    },
    modalContainerStyles: { type: Object, default: () => null },
    useMenuBg: {
      type: Boolean,
      default: false,
    },
    headerVariant: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    renderAlign() {
      switch (this.align) {
        case 'right':
          return 'flex-end';
        case 'left':
          return 'flex-start';
        default:
          return 'center';
      }
    },
    renderVAlign() {
      switch (this.valign) {
        case 'bottom':
          return 'flex-end';
        case 'top':
          return 'flex-start';
        default:
          return 'center';
      }
    },
    isMobileLandscape() {
      return isMobile && this.$screen.width > this.$screen.height;
    },
  },
  methods: {
    handlerAfterEnter() {
      this.display = true;
    },
    clickOutside() {
      if (!this.overlayClickable) {
        return;
      }

      this.$emit('close');
    },
    getBorderRadiusBySides(val) {
      return this.borderRadiusBySide[val];
    },
  },
  watch: {
    active: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$emit('open');
        } else if (!newVal && oldVal) {
          this.$emit('close');
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.global-modal {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  -webkit-transition: background 0.5s ease-out;
  -moz-transition: background 0.5s ease-out;
  -o-transition: background 0.5s ease-out;
  transition: background 0.5s ease-out;
  z-index: 4999;

  &.no-background {
    background: unset;
  }

  .modal-header {
    height: 56px;
    margin: 0;
    padding: 12px 16px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    text-transform: uppercase;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    background-color: #10233a;
    // background-image: repeating-linear-gradient(
    //   -45deg,
    //   rgba(88, 56, 130, 0.35) 0,
    //   rgba(88, 56, 130, 0.35) 2px,
    //   transparent 2px,
    //   transparent 8px
    // );
    flex-shrink: 0;

    &.is-mobile {
      height: 40px;
      padding: 8px 16px;
    }

    &.is-tabs {
      height: auto;
      padding: 0;
      background: transparent;
      background-image: none;
      box-shadow: none;
    }
  }
  &.full-size {
    height: 100%;
    > .modal-container {
      width: 100% !important;
      height: 100% !important;
    }
  }

  &:not(.full-size) {
    @include pad-and-up {
      > .modal-container {
        margin: auto 0;
      }
    }
  }

  .modal-container {
    max-width: 90%;
    height: 100%;
    border-radius: 6px;
    overflow: hidden;
    color: #ffffff;
    box-shadow: 0 3px 99px 0 rgba(0, 0, 0, 0.8);
    background-color: #07182c;
    display: flex;
    flex-direction: column;
    isolation: isolate;

    &.has-menu-bg {
      background-color: #07182c;
    }
  }
}

.burger-menu {
  position: fixed;
  z-index: 1;
  bottom: 28px;
  right: 16px;
}
.landscape .burger-menu {
  bottom: 6px;
  right: 15px;
}
.desktop .burger-menu {
  top: 8px;
  right: 8px;
  bottom: unset;
}
/* parent container fade */
.fade-parent-enter {
  opacity: 0;
}
.fade-parent-enter-active {
  transition: opacity 0.2s;
}
.fade-parent-leave {
  opacity: 1;
}
.fade-parent-leave-active {
  transition: opacity 0.2s;
  opacity: 0;
}

/* fade */
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave {
  opacity: 1;
}
.fade-leave-active {
  transition: opacity 0.5s;
  opacity: 0;
}
/* slide up */
.slide-up-enter-active {
  transition: all 0.3s ease;
}
.slide-up-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100px);
  opacity: 0;
}
/* slide down */
.slide-down-enter-active {
  transition: all 0.3s ease;
}
.slide-down-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-100px);
  opacity: 0;
}
/* slide left */
.slide-left-enter-active {
  transition: all 0.3s ease;
}
.slide-left-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-left-enter,
.slide-left-leave-to,
.slide-left-leave-active {
  transform: translateX(35%);
  opacity: 0;
}

div {
  @include borderBox;
}
</style>
